import { useTranslation } from "react-i18next";

export default function ExploreOurProducts({ productLinks }) {
  const { t } = useTranslation();
  return (
    <>
      <h2>{t("ExploreOurProducts-title")}</h2>

      <p className="text-sm py-1">{t("ExploreOurProducts-subTitle")}</p>
      <hr />

      <div className="ui-card">
        {productLinks.map((product) => (
          <div className="px-4 py-2" key={JSON.stringify(product)}>
            <a
              href={product.url}
              target="_blank"
              rel="noreferrer"
              className="ui-link-icon gap-2"
            >
              <svg
                className="ui-icon w-4 h-4"
                focusable="false"
                aria-hidden="true"
                role="presentation"
              >
                <use href="#ui-icon-external-link" />
              </svg>
              {product.name}
            </a>
          </div>
        ))}
      </div>
    </>
  );
}
